import styled from 'styled-components';

const StyledLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  overflow: hidden;
  z-index: 5;
  transform: translateY(0);
  transition: transform .5s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;
  &.loaded{
    transform: translateY(100%);
  }
  img{
    width: 24px;
    display: block;
    margin: 0 auto 24px;
  }
  
`;

export {
  StyledLoader,
};

